export default {
  hasActiveCampaign: false,
  campaignInfo: {},
  isCampaignActive: false
};
